import DeleteButton from "@app/components/delete-button.tsx";
import { PerformanceModel } from "@app/data/engine.ts";
import { formatUsd } from "@app/helpers/money-helper.ts";
import { formatDate } from "@app/helpers/time-helper";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { createColumnHelper, IconButton } from "bi-lib";

interface Props {
    onEdit: (item: PerformanceModel) => void;
    onDelete: (id: number) => void;
    rowCount: number;
}

const columnHelper = createColumnHelper<PerformanceModel>();
export const staffPerformanceTableDefinition = ({ onEdit, onDelete, rowCount }: Props) => [
    columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (item) => (
            <Box display={"flex"}>
                <IconButton tooltip={"Edit"} onClick={() => onEdit(item.row.original)}>
                    <EditIcon />
                </IconButton>
                <DeleteButton onDelete={() => onDelete(item.row.original.performanceId!)} />
            </Box>
        ),
        footer: () => `${rowCount} Rows`,
    }),
    columnHelper.accessor((x) => x.effectiveDate, {
        id: "effectiveDate",
        header: "Effective Date",
        cell: (item) => formatDate(item.getValue()),
    }),
    columnHelper.accessor((x) => x.targetBillingRate, {
        id: "targetBillingRate",
        header: "Target Bill Rate",
        cell: (item) => formatUsd(item.getValue()),
        alignment: "right",
    }),
    columnHelper.accessor((x) => x.targetUtilizationRate, {
        id: "targetUtilizationRate",
        header: "Target Utilization",
        cell: (item) => formatUsd(item.getValue()),
        alignment: "right",
    }),
];
